import React, { useState, Fragment } from 'react';
import Pagination from 'react-js-pagination';

import { PAGE_SIZE } from 'config';
import SearchInput from 'components/analytics/searchInput';
import LearnersListing from 'pages/insights/containers/learnersAnalyticsContainer/components/learnersListing';
import { learnersAnalyticsActions } from 'pages/insights/containers/learnersAnalyticsContainer/actions';
import { Row, Col, Table } from 'react-bootstrap';
import InsightsLoader from 'components/loaders/InsightsLoader';

const LearnersOverview = (props) => {
  const { learners_count, learners_data, current_page, dispatch } = props;
  const [searchText, setSearchText] = useState('');
  const [isLoaded, setIsLoaded] = useState(true);
  const [timer, setTimer] = useState(null);
  const [userFilters, setUserFilters] = useState({
    column: 'profile__name',
    direction: 'desc asc'
  });

  const stopLoader = () => {
    setIsLoaded(true);
  };

  const handlePageChange = (page_number) => {
    setIsLoaded(false);
    let payload = { page: page_number, search: searchText, learners_only: 'true' };
    if (userFilters.direction !== 'desc asc') {
      payload['ordering'] = userFilters.direction === 'asc' ? userFilters.column : `-${userFilters.column}`;
    }
    dispatch(learnersAnalyticsActions.fetchUsersDetailAnalytics(payload, stopLoader));
  };

  const handleInputChange = (event) => {
    setIsLoaded(false);
    let search = event.target.value;
    setSearchText(search);
    clearTimeout(timer);
    setTimer(
      setTimeout(() => {
        dispatch(
          learnersAnalyticsActions.fetchUsersDetailAnalytics(
            { page: 1, search: search, learners_only: 'true' },
            stopLoader
          )
        );
      }, 400)
    );
  };

  const onSort = (columnName) => {
    setIsLoaded(false);
    const direction = userFilters.column ? (userFilters.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    setUserFilters({
      ...userFilters,
      column: columnName,
      direction: direction
    });

    let order_by = `${columnName}`;
    if (direction === 'desc') {
      order_by = `-${columnName}`;
    }
    setTimer(
      setTimeout(() => {
        dispatch(
          learnersAnalyticsActions.fetchUsersDetailAnalytics(
            {
              search: searchText,
              ordering: order_by,
              learners_only: 'true'
            },
            stopLoader
          )
        );
      }, 400)
    );
  };

  return (
    <Fragment>
      <div className="learner-overview-header">
        <Row className="mb-4">
          <Col xs="12" md="6">
            <h5 className="mb-0">Learners Overview</h5>
            <small className="d-block mb-3 mb-md-0">Current Page: {current_page}</small>
          </Col>
          <Col xs="12" md="6" className="d-flex justify-content-md-end align-items-center">
            <SearchInput label="Search Learner" searchText={searchText} handleInputChange={handleInputChange} />
          </Col>
        </Row>
      </div>
      <div className="table-container table-holder">
        <Table size="sm" className="align-middle">
          <thead>
            <tr>
              <th>
                <span
                  className={
                    userFilters.column === 'profile__name' ? `sorter ${userFilters.direction}` : 'sorter asc desc'
                  }
                  onClick={() => onSort('profile__name')}
                >
                  Name/Email
                </span>
              </th>
              <th className="text-center">
                <span>Courses Enrolled</span>
              </th>
              <th className="text-center">
                <span>Courses Completed</span>
              </th>
              <th className="text-center">
                <span
                  className={
                    userFilters.column === 'date_joined' ? `sorter ${userFilters.direction}` : 'sorter asc desc'
                  }
                  onClick={() => onSort('date_joined')}
                >
                  Account Created
                </span>
              </th>
              <th className="text-center">
                <span
                  className={
                    userFilters.column === 'last_login' ? `sorter ${userFilters.direction}` : 'sorter asc desc'
                  }
                  onClick={() => onSort('last_login')}
                >
                  Last Login
                </span>
              </th>
            </tr>
          </thead>
          {isLoaded && learners_count > 0 && (
            <tbody>
              <LearnersListing learners_count={learners_count} learners_data={learners_data} />
            </tbody>
          )}
        </Table>
        {!isLoaded && <InsightsLoader />}
        {learners_count === 0 && isLoaded && (
          <div className="no-data-found d-flex justify-content-center align-items-center">
            <p className="mb-0">No data</p>
          </div>
        )}
      </div>
      <div className="table-footer mb-4">
        <Pagination
          activePage={current_page}
          itemsCountPerPage={PAGE_SIZE}
          totalItemsCount={learners_count}
          pageRangeDisplayed={5}
          onChange={handlePageChange}
        />
      </div>
    </Fragment>
  );
};

export default LearnersOverview;
